import { storyblokEditable } from '@storyblok/react';
import Image from 'next/image';
import { FC } from 'react';

import Container from '@/components/elements/Container';
import Section from '@/components/elements/Section';
import StandardText, {
  StandardTextSize,
} from '@/components/elements/StandardText';

export interface ImagesProps {
  blok: any;
}

const Images: FC<ImagesProps> = ({ blok }) => {
  return (
    <Section {...storyblokEditable(blok)} className="overflow-hidden">
      <Container size={'widest'}>
        <StandardText blok={blok} size={StandardTextSize.MD} />
      </Container>
      <Container size={'widest'} className="relative mt-16">
        {blok.images.map((v) => (
          <Image
            key={v.id}
            {...v}
            src={v.filename}
            className="h-auto w-full"
            alt={v.alt}
            width={2048}
            height={2048}
            sizes="100vw"
          />
        ))}
      </Container>
    </Section>
  );
};

export default Images;
